import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, StackBlock } from '@yonderland/andes-react';
import { CheckoutBlockedReason, DeliveryOptionsEnum, } from '@as-react/common-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetBasketClickAndCollectStoreIdState, makeGetBasketDeliveryInfoState, makeGetBasketMappedProductsState, } from '../../../redux/basket/selectors/BasketSelector';
import { isDeliveryMessageCollectStoreOrHQ } from '../../../util/DeliveryPromiseUtil';
import { Fragment, useEffect, useMemo } from 'react';
import { BasketOverviewItem } from './BasketOverviewItem';
import { storeQueries } from '@as-react/common-queries';
import { useAemConfig } from '@as-react/common-components';
import { useQuery } from '@tanstack/react-query';
import StoreUtil from '../../../util/StoreUtil';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
const getProductDisabledReason = (product, deliveryMessages) => {
    if (isDeliveryMessageCollectStoreOrHQ(deliveryMessages)) {
        if (product.ccExcluded) {
            return CheckoutBlockedReason.CC_EXCLUDED;
        }
        else if (product.sseProduct && !product.availableInSSEStore) {
            return CheckoutBlockedReason.SSE_PRODUCT;
        }
        else if (product.specialtyStoreProduct && !product.availableInSpecialtyStore) {
            return CheckoutBlockedReason.SPECIALTY_PRODUCT;
        }
    }
    else {
        if (product.sseProduct) {
            return CheckoutBlockedReason.SSE_PRODUCT;
        }
    }
};
export const BasketOverviewItems = () => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { defaultRequestParams, servicesEndpoint, businessUnitId, mainWebShop } = useAemConfig();
    const dispatch = useDispatch();
    const deliveryInfo = useSelector(makeGetBasketDeliveryInfoState());
    const clickAndCollectStoreId = useSelector(makeGetBasketClickAndCollectStoreIdState());
    const products = useSelector(makeGetBasketMappedProductsState());
    const { getStoreInformation } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const isCheckoutFlowDisabled = products.some(product => isDeliveryMessageCollectStoreOrHQ(deliveryInfo.deliveryMessages)
        ? product.ccExcluded ||
            (product.sseProduct && !product.availableInSSEStore) ||
            (product.specialtyStoreProduct && !product.availableInSpecialtyStore)
        : product.sseProduct);
    const { data: storeInformation } = useQuery(getStoreInformation({
        businessUnitId,
        storeId: clickAndCollectStoreId,
    }, {
        enabled: !!clickAndCollectStoreId &&
            (!!((_a = deliveryInfo.deliveryMessages) === null || _a === void 0 ? void 0 : _a[DeliveryOptionsEnum.COLLECT_STORE]) || isCheckoutFlowDisabled),
    }));
    const storeName = storeInformation ? StoreUtil.getStoreName(storeInformation, mainWebShop, t) : undefined;
    const disabledProductsList = useMemo(() => {
        return products.reduce((acc, product) => {
            const reason = getProductDisabledReason(product, deliveryInfo.deliveryMessages);
            if (!reason) {
                return acc;
            }
            return Object.assign(Object.assign({}, acc), { [product.productId]: reason });
        }, {});
    }, [products, deliveryInfo]);
    useEffect(() => {
        if (isCheckoutFlowDisabled) {
            dispatch(analyticsActions.blockedCheckout(disabledProductsList));
        }
    }, [disabledProductsList]);
    return (_jsx(StackBlock, { gap: "8", children: products.map((product, index, arr) => (_jsxs(Fragment, { children: [_jsx(BasketOverviewItem, { product: product, isDisabled: product.productId in disabledProductsList, storeName: storeName }), arr.length - 1 !== index && _jsx(Divider, {})] }, `${product.sku}_${index}`))) }));
};
